const NAMESPACE = "pcCategorizedDatafields";

const KEYS = {
    fieldsHeader: "fieldsHeader",
    hiddenCategoryLabel: "hiddenCategoryLabel",
    otherCategoryLabel: "otherCategoryLabel",
    fieldTypeCategoryLabel: "fieldTypeCategoryLabel",
    groupTypeCategoryLabel: "groupTypeCategoryLabel",
    unreferencedOptionLabel: "unreferencedOptionLabel",
    archivedOptionLabel: "archivedOptionLabel",
    fieldOptionLabel: "fieldOptionLabel",
    groupOptionLabel: "groupOptionLabel",
    attachmentOptionLabel: "attachmentOptionLabel",
    builtInOptionLabel: "builtInOptionLabel",
    communicationOptionLabel: "communicationOptionLabel",
    deadlineOptionLabel: "deadlineOptionLabel",
    booleanOptionLabel: "booleanOptionLabel",
    choiceOptionLabel: "choiceOptionLabel",
    dateOptionLabel: "dateOptionLabel",
    decimalOptionLabel: "decimalOptionLabel",
    integerOptionLabel: "integerOptionLabel",
    stringOptionLabel: "stringOptionLabel",
    userOptionLabel: "userOptionLabel",
    locationOptionLabel: "locationOptionLabel",
    addressOptionLabel: "addressOptionLabel",
    contactOptionLabel: "contactOptionLabel",
    customListOptionLabel: "customListOptionLabel",
    essOptionLabel: "essOptionLabel",
    incentiveOptionLabel: "incentiveOptionLabel",
    nameOptionLabel: "nameOptionLabel",
    pvSystemOptionLabel: "pvSystemOptionLabel"
};

const MESSAGES = {
    [KEYS.fieldsHeader]: {
        value: "Fields",
        comment: "Header for area that contains the fields after they've been filtered."
    },
    [KEYS.hiddenCategoryLabel]: {
        value: "Hidden Fields",
        comment: "Label for section that contains filters for field that may be hidden by special attributes."
    },
    [KEYS.otherCategoryLabel]: {
        value: "Other Types",
        comment: "Label for section that contains filters for other types of data."
    },
    [KEYS.fieldTypeCategoryLabel]: {
        value: "Data Field Types",
        comment: "Label for section that contains type filters for Data Fields."
    },
    [KEYS.groupTypeCategoryLabel]: {
        value: "Data Field Group Types",
        comment: "Label for section that contains type filters for Data Field Groups."
    },
    [KEYS.unreferencedOptionLabel]: {
        value: "Show fields not referenced on current forms",
        comment: "Label for checkbox that toggles whether unreferenced fields are included in the filter."
    },
    [KEYS.archivedOptionLabel]: {
        value: "Show archived fields",
        comment: "Label for checkbox that toggles whether archived fields are included in the filter."
    },
    [KEYS.fieldOptionLabel]: {
        value: "Data Field",
        comment: "Label for checkbox that toggles whether data fields are included in the filter."
    },
    [KEYS.groupOptionLabel]: {
        value: "Data Field Group",
        comment: "Label for checkbox that toggles whether data field groups are included in the filter."
    },
    [KEYS.attachmentOptionLabel]: {
        value: "Attachment",
        comment: "Label for checkbox that toggles whether attachment fields are included in the filter."
    },
    [KEYS.builtInOptionLabel]: {
        value: "Built-In",
        comment: "Label for checkbox that toggles whether built-in fields are included in the filter."
    },
    [KEYS.communicationOptionLabel]: {
        value: "Communication",
        comment: "Label for the checkbox that toggles whether communications are included in the filter"
    },
    [KEYS.deadlineOptionLabel]: {
        value: "Deadline",
        comment: "Label for the checkbox that toggles whether deadlines are included in the filter"
    },
    [KEYS.booleanOptionLabel]: {
        value: "Boolean",
        comment: "Label for checkbox that toggles whether data fields with a Boolean type are included in the filter."
    },
    [KEYS.choiceOptionLabel]: {
        value: "Choice",
        comment: "Label for checkbox that toggles whether data fields with a Choice type are included in the filter."
    },
    [KEYS.dateOptionLabel]: {
        value: "Date",
        comment: "Label for checkbox that toggles whether data fields with a Date type are included in the filter."
    },
    [KEYS.decimalOptionLabel]: {
        value: "Decimal",
        comment: "Label for checkbox that toggles whether data fields with a Decimal type are included in the filter."
    },
    [KEYS.integerOptionLabel]: {
        value: "Integer",
        comment: "Label for checkbox that toggles whether data fields with an Integer type are included in the filter."
    },
    [KEYS.stringOptionLabel]: {
        value: "String",
        comment: "Label for checkbox that toggles whether data fields with a String type are included in the filter."
    },
    [KEYS.userOptionLabel]: {
        value: "User",
        comment: "Label for checkbox that toggles whether data fields with a User type are included in the filter."
    },
    [KEYS.locationOptionLabel]: {
        value: "Location",
        comment: "Label for checkbox that toggles whether data fields with a Location type are included in the filter."
    },
    [KEYS.addressOptionLabel]: {
        value: "Address",
        comment:
            "Label for checkbox that toggles whether data field groups with an Address type are included in the filter."
    },
    [KEYS.contactOptionLabel]: {
        value: "Contact",
        comment:
            "Label for checkbox that toggles whether data field groups with a Contact type are included in the filter."
    },
    [KEYS.customListOptionLabel]: {
        value: "Custom List",
        comment:
            "Label for checkbox that toggles whether data field groups with a Custom List type are included in the filter."
    },
    [KEYS.essOptionLabel]: {
        value: "Energy Storage System",
        comment:
            "Label for checkbox that toggles whether data field groups with an Energy Storage System type are included in the filter."
    },
    [KEYS.incentiveOptionLabel]: {
        value: "Incentive",
        comment:
            "Label for checkbox that toggles whether data field groups with an Incentive type are included in the filter."
    },
    [KEYS.nameOptionLabel]: {
        value: "Name",
        comment:
            "Label for checkbox that toggles whether data field groups with a Name type are included in the filter."
    },
    [KEYS.pvSystemOptionLabel]: {
        value: "PV System",
        comment:
            "Label for checkbox that toggles whether data field groups with a PV System type are included in the filter."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
